import type { AppState } from '../appstate';

export type ComposedState = { appState: AppState } & { packageState: SearchBoxState };
export type SearchSuggestionsMapType = { [query: string]: SearchSuggestionQueryType };
export type SearchSuggestionQueryType = {
    suggestions: string[];
    isError: boolean;
    isLoading: boolean;
};

export interface SearchBoxState {
    readonly searchBoxText?: string;
    // legacy suggestions, powered by client-reranked search results + local state.
    readonly searchSuggestions?: SearchSuggestionsMapType;
    readonly isSearchBoxExpanded: boolean;
    readonly personaPillId?: string;
}

export const packageStateKey = 'searchBox';
